// Entity
import { StoreEntityState } from "@ms/uno-constants/lib/local/StoreConstants";
/**
 * Upsert a versioned baseline into a table
 * @param table The table to upsert the baseline into
 * @param id Id of the entity
 * @param newBaseline New baseline to upsert
 */ export function upsertVersionedBaseline(table, id, newBaseline) {
    const current = table.get(id);
    if (!current) {
        table.add(id, newBaseline);
        return true;
    } else if (current.baseline.itemVersion < newBaseline.itemVersion) {
        current.updateBaseline(newBaseline);
        return true;
    }
    return false;
}
/**
 * Type guard to check if a store implements IPersistedStore
 * @param store The store to check
 */ export function isPersistedStore(store) {
    return store != null && typeof store === "object" && typeof store.getPersistedTables === "function";
}
/**
 * Check if a store is enabled for data persistence and persistent storage is available
 * @param configProvider The config provider to check
 * @param persistentStorage The persistent storage to check
 */ export function isPersistedStorageEnabled(configProvider, persistentStorage) {
    return configProvider().flights.EnableTasksDataPersistence && persistentStorage !== null;
}
/**
 * Default status for an unfetched store entity.
 * This status indicates that the entity has not been fetched yet.
 */ export const AbsentStoreEntityStatus = {
    isFetching: false,
    state: StoreEntityState.Absent,
    timestamp: null
};
